import { combineEpics } from 'redux-observable';
import { listTourEventsEpic } from '@webapp/store/traclink/effects/get-tourevents';
import { AddTourEventEpic } from '@webapp/store/traclink/effects/add-tourevent';
import { UpdateTourEventEpic } from '@webapp/store/traclink/effects/update-tourevent';
import { DeleteTourEventEpic } from '@webapp/store/traclink/effects/delete-tourevent';
import { storeEventDrafts } from './store-event-drafts';

const tracLinkEpic = combineEpics(
  listTourEventsEpic,
  AddTourEventEpic,
  UpdateTourEventEpic,
  DeleteTourEventEpic,
  storeEventDrafts
);

export default tracLinkEpic;
